// src/cmps/review/ReviewList.jsx
import { ReviewPreview } from './ReviewPreview'

export function ReviewList({ reviews = [], loggedInUser, users = [] }) {
  if (!reviews.length) {
    return <p className="text-red-500">אין ביקורות עדיין.</p>
  }

  // מיון ביקורות לפי תאריך (מהחדש לישן)
  const sortedReviews = [...reviews].sort((a, b) => b.createdAt - a.createdAt)

  return (
    <div>
      {sortedReviews.map((review) => (
        <ReviewPreview
          key={review._id}
          review={review}
          loggedInUser={loggedInUser}
          users={users}
        />
      ))}
    </div>
  )
}
